import Swiper from 'swiper/dist/js/swiper.js';
import owd from 'owd/owd';
import browser from 'owd/utils/browser';

export default class Slider extends owd.Component {
	init() {
		this.$element.addClass('is-building');
		this.$slides = this.$element.find('[data-slide]')
		this.count = this.$slides.length;
		this.curr = 1;

		if (this.$element.is('[data-slider="home-hero"]')) {
			this.$currSlide;
			this.currVideo;
			this.$videos = this.$element.find('[data-slide-video]');
		}

		this.prepareDom();
		this.createSlider();
		this.updateSize();

		this.bind();

		// if (this.swiper.params.init == false) {
		// 	this.swiper.init();

		// 	this.swiper.params.init == true;
		// }
	}

	prepareDom() {
		this.$element.append('<div class="swiper-container"><div class="swiper-wrapper"></div></div>');
		this.$element.find('.swiper-wrapper').append(this.$element.find('[data-slide]'));
		this.$element.find('[data-slide]').addClass('swiper-slide').each((index, item) => {
			$(item).attr('data-slide-number', index);
		});

		this.$swiperContainer = this.$element.find('.swiper-container');
	}

	getOptions() {
		let init = true;
		let loop = true;
		let keyboardControl = true;
		let effect = 'fade';
		let autoplay = {
			delay: 5000
		};
		let speed = 500;
		let on = {};
		let controller = {};
		let pagination = {};
		let lazyload = this.$swiperContainer.find('.swiper-lazy').length ? true : false;
		let lazy = lazyload ? {
			loadPrevNext: lazyload,
			loadPrevNextAmount: 1,
		} : false;
		let loopedSlides;
		let initialSlide = 0;

		if (this.$element.is('[data-slider="home-hero"]')) {
			autoplay = false;
			init = false;
			loop = true;
			speed = 0;
			// loopAdditionalSlides = 9; // ((data-slider=pagination).slidesPerView - 1)
			loopedSlides = this.count; // ((data-slider=pagination).slidesPerView - 1)
			initialSlide = this.$element.data('initial-slide') ? this.$element.data('initial-slide') : Math.floor(Math.random() * (this.count-1));

			this.$element.data('initial-slide', initialSlide);
		
			on = {
				init: () => {
					this.$element.find('.swiper-slide-duplicate').each(function() {
						$(this).find('[data-owd-component]').removeAttr('data-owd-component');
						$(this).find('.video-iframe-polyfill').remove();
						$(this).trigger('owd.tick');
					});

					setTimeout(() => {
						this.slideVideoBind();
						this.slideVideoPlay();
						this.maybeLinkHomeWithPagination();
						this.updateSize();
					});
				},

				slideChange: () => {
					this.slideVideoStop(true);
					this.slideVideoPlay();
				},

				touchStart: () => {
					this.$currSlide.addClass('has-transition');
					this.slideVideoStop();
				},

				touchEnd: () => {
					this.$slides.removeClass('has-transition');
					this.slideVideoPlay();
				}
			}
		}

		if (this.$element.is('[data-slider="beliefs-visual"]') || this.$element.is('[data-slider="beliefs-copy"]')) {
			init = false;
			speed = 0;
		}

		if (this.$element.is('[data-slider="beliefs-copy"]')) {
			pagination = {
				el: this.$element.find('[data-slider-pagination]'),
				clickable: true,
				renderBullet: (index, className) => {
					return '<button type="button" class="' + className + '">' + '<span class="' + className + '-label">' + index + '</span><span class="' + className + '-bar"></span>' + '</button>';
				},
				bulletClass: 'beliefs-pagination-item',
				bulletActiveClass: 'is-active',
				modifierClass: 'beliefs-pagination-',
				clickableClass: 'is-clickable'
			};

			on = {
				init: function () {
					this.controller.control = $('body').find('[data-slider="beliefs-visual"]').data('swiperInstance');
				}
			}

			autoplay = {
				delay: 4000,
				disableOnInteraction: false
			};
		}

		if (this.$element.is('[data-slider="beliefs-visual"]')) {
			autoplay = false;
			on = {
				init: function () {
					this.controller.control = $('body').find('[data-slider="beliefs-copy"]').data('swiperInstance');
				}
			}
		}

		let options = {
			init: init,
			keyboardControl: keyboardControl,
			effect: effect,
			loop: loop,
			// loopAdditionalSlides: loopAdditionalSlides,
			loopedSlides: loopedSlides,
			speed: speed,
			on: on,
			pagination: pagination,
			controller: controller,
			autoplay: autoplay,
			preloadImages: !lazyload,
			lazy,
			initialSlide: initialSlide,
			prevButton: this.$element.find('.button--prev')[0],
			nextButton: this.$element.find('.button--next')[0],
		};

		if (this.$element.is('[data-slider="pagination"]')) {
			let $heroSlider = $('[data-slider="home-hero"]');

			options.init = false;
			options.speed = 200;
			options.direction = 'vertical';
			options.slidesPerView = 10;
			options.effect = 'slide';
			options.freeMode = true;
			options.loop = true;
			options.autoplay = false;
			options.slideToClickedSlide = true;
			options.centeredSlides = true;
			options.slideActiveClass = 'is-active';
			options.loopedSlides = this.count;
			options.initialSlide = $heroSlider.data('initial-slide') ? $heroSlider.data('initial-slide') : Math.floor(Math.random() * (this.count-1));

			$heroSlider.data('initial-slide', options.initialSlide);

			// options.navigation = {
			// 	prevEl: this.$element.find('[data-slider-prev]'),
			// 	nextEl: this.$element.find('[data-slider-next]')
			// }

			options.on = {
				init: () => {
					this.maybeLinkHomeWithPagination();
				}
			}
		}

		return options;
	}

	createSlider() {
		let options = this.getOptions();

		this.swiper = new Swiper(this.$swiperContainer[0], options);

		this.$element.data('swiperInstance', this.swiper);
		this.$element.trigger('sliderInitialized', this.swiper);

		if (this.$element.is('[data-slider="beliefs-copy"]')) {
			this.$element.find('[data-slider-pagination]').css({
				'animation-duration' : options.autoplay.delay + 'ms'
			})
		}
	}

	maybeLinkHomeWithPagination() {
		let paginationSwiper = $('[data-slider="pagination"]').data('swiperInstance');
		let heroSwiper = $('[data-slider="home-hero"]').data('swiperInstance');

		if (paginationSwiper && heroSwiper) {
			if (window.matchMedia('(min-width: 768px').matches) {
				heroSwiper.controller.control = paginationSwiper;
				paginationSwiper.controller.control = heroSwiper;
			} else {
				heroSwiper.controller.control = null;
				paginationSwiper.controller.control = null;
			}
		}
	}

	slideVideoBind() {
		console.log('binding slideVideoBind', this.$element.find('[data-video]').length);
		this.$element.find('[data-video]').each((index, video) => {
			this.on('ended iframe-ended', $(video), () => {
				if (this.currVideo === video) {
					if (video._i === undefined) {
						video._i = 0;
					}

					if (video._i < 2) {
						video._i++;
						video.currentTime = 0;
						console.log('calling reply');
						$(video).data('videoApi').reply();
					} else {
						video._i = 0;
						this.swiper.slideNext();
					}
				}
			});
		});
	}

	slideVideoPlay() {
		this.$currSlide = this.$slides.eq(this.swiper.realIndex);
		this.currVideo = this.$currSlide.find('[data-slide-video]')[0];

		if (this.currVideo !== undefined) {

			this.currVideo._i = 0;
			this.currVideo.currentTime = 0;
			console.log('calling play');
			$(this.currVideo).data('videoApi').play();
			
			this.$currSlide.addClass('has-video-playing');

		}
	}

	slideVideoStop(stopVideo) {
		if (this.currVideo !== undefined) {
			this.currVideo._i = 0;
			// this.currVideo.pause();
		}

		if (stopVideo === true && this.$currSlide) {
			this.$currSlide.removeClass('has-video-playing');
		}
		// this.$currSlide.removeClass('has-video-playing');
	}

	updateSize() {
		if (this.$element.is('[data-slider="home-hero"]')) {
			setTimeout(() => {
				if (window.matchMedia('(min-width: 1025px)').matches) {
					this.$element.parents('.section-container').css({
						height: ''
					});
					
					let height = 0;
					this.$element.find('.swiper-slide').each((index, item) => {
						height = Math.max($(item).height(), height);
					});

					this.$element.parents('.section-container').css({
						height: height + parseFloat($('.section--home-hero .hero-slider').css('margin-bottom'))
					});
				} else {
					// this.$element.parents('.section-container, .hero-slider').css({
					// 	height: ''
					// });
				}
			});
		}
	}

	bind() {
		this.on('slideChangeStart', this.swiper, () => {
			this.curr = parseInt(this.$element.find('.swiper-slide-active').data('slide-number')) + 1;
			$('.curr-slide').html(this.curr);
		});

		this.on('init', this.swiper, () => {
			// console.log(this.swiper.virtualSize);
		});

		this.on('resize', this.dom.$window, () => {
			this.updateSize();
		});

		this.on('load ajaxload pageIn pageInEnd', this.dom.$window, (e) => {
			if (this.swiper) {
				this.swiper.update();
			}

			if (this.swiper.params.init == false) {
				this.swiper.init();
	
				this.swiper.params.init == true;
			}
		});
		
		this.on('resize', this.dom.$window, (e) => {
			this.maybeLinkHomeWithPagination();
		});

		this.on('imageload', 'img', (e) => {
			if (this.swiper) {
				this.swiper.update();
			}
		});

		if (this.$element.is('[data-slider="home-hero"]')) {
			// this.on('ended', this.$videos, (e) => {
			// 	$(e.target).closest('[data-slide]').removeClass('has-video-playing');
			// });
		}

		if (this.$element.is('[data-slider="pagination"]')) {
			this.on('click', this.$element.find('[data-slider-prev]'), () => {
				this.swiper.slidePrev(100);
			})

			this.on('click', this.$element.find('[data-slider-next]'), () => {
				this.swiper.slideNext(100);
			})
			// 
			// this.on('click', this.dom.$window, this.$element.find('[data-slide]'), () => {
			// 	console.log(this.swiper.realIndex);
			// })
		}
	}

	destroy() {
		super.destroy();

		if (this.slider) {
			this.swiper.destroy();
		}
	}
}

owd.registerComponent('slider', {
	component: Slider
});
